import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext(null);

const API = '/api';

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    organization_name: 'NMLRA',
    primary_color: '#1B3B6F',
    secondary_color: '#C9A227',
    sidebar_color: '#1B3B6F',
    logo_url: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/settings`);
      if (res.data) {
        setSettings(prev => ({
          ...prev,
          organization_name: res.data.organization_name || 'NMLRA',
          primary_color: res.data.primary_color || '#1B3B6F',
          secondary_color: res.data.secondary_color || '#C9A227',
          sidebar_color: res.data.sidebar_color || '#1B3B6F',
          logo_url: res.data.logo_url || null,
        }));
        
        // Apply CSS variables
        applyTheme(res.data);
      }
    } catch (error) {
      console.error('Failed to load settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const applyTheme = (data) => {
    const root = document.documentElement;
    
    // Apply colors as CSS variables
    if (data.primary_color) {
      root.style.setProperty('--primary-color', data.primary_color);
    }
    if (data.secondary_color) {
      root.style.setProperty('--secondary-color', data.secondary_color);
    }
    if (data.sidebar_color) {
      root.style.setProperty('--sidebar-color', data.sidebar_color);
      // Also update sidebar background directly
      const sidebar = document.querySelector('.sidebar');
      if (sidebar) {
        sidebar.style.backgroundColor = data.sidebar_color;
      }
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings, applyTheme }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
}
